import { useParams } from "react-router-dom";
import React from "react";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { useDataApiDepartmentById } from "../../Hooks/useDataServicesApi";
import { DepartmentEdit } from "../../components/departments/department";

// Pour récupérer le contenu en format RAW

const EditDepartment: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const departmentAPI = useDataApiDepartmentById(Number.parseInt(id));

    if (!departmentAPI) {
        return (<>Loading...</>)
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    }

    return (
        <div>
            <DepartmentEdit {...departmentAPI}></DepartmentEdit>
        </div>
    );
};

export { EditDepartment };